import {FC, PropsWithChildren} from "react";

interface Props extends PropsWithChildren {
    header?: boolean;
    width?: string;
    colSpan?: number;
    className?: string;
}

const RightAlignedColumn: FC<Props> = (props) => {
    return props.header ? (
            <th {...props} className={(props.className || "") + " text-end"}
                colSpan={props.colSpan}
                style={{width: props.width, backgroundColor: "antiquewhite"}}> {props.children} </th>
        ) :
        (
            <td {...props} className={(props.className || "") + " text-end"}
                colSpan={props.colSpan}
                style={{width: props.width}}> {props.children} </td>
        )
}

export default RightAlignedColumn;
